<template>
  <footer class="styled__Footer-sc-1f4sur5-0 buGLQK footer">
    <div class="Container-war86y-0 dUjVdf">
      <div class="styled__Content-sc-1f4sur5-1 dhMLsO">
        <ul class="styled__Menu-sc-1f4sur5-4 btPnMK">
          <li
            @click="clickAbout('about')"
            class="styled__Li-sc-14y8vvx-3 dLKKpp"
          >
            <router-link to="/">About</router-link>
          </li>
          <li @click="clickAbout(false)" class="styled__Li-sc-14y8vvx-3 dLKKpp">
            <router-link to="/privacy">Privacy Policy</router-link>
          </li>
          <li @click="clickAbout(false)" class="styled__Li-sc-14y8vvx-3 dLKKpp">
            <router-link to="terms">Terms of Use </router-link>
          </li>
        </ul>

        <p class="styled__Copy-sc-1f4sur5-3 dLuyJA">
          Ⓒ {{ yearTime }} Top Ringtones Apps
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      yearTime: new Date().getFullYear()
    };
  },
  methods: {
    clickFoot() {
      setTimeout(() => {
        window.scrollTo(0, 0);
      });
    },
    clickAbout(val) {
      setTimeout(() => {
        let scrollVal = 0;
        if (val) {
          const dom = document.querySelector("#about");
          const domTop = dom && dom.getBoundingClientRect().top;
          const scrollTop =
            document.body.scrollTop || document.documentElement.scrollTop;
          scrollVal = domTop + scrollTop;
        }
        window.scrollTo(0, scrollVal);
      });
    }
  }
};
</script>

<style scoped>
/* .footer-black {
  margin-top: 1rem;
} */
.p-small {
  text-align: center;
  margin: 1rem 0 !important;
}
.list-inline-item {
  margin: 12px 24px;
}
.footer {
  margin-top: 24px;
}
</style>
